/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const pay_from = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="m10.194 1.062.322.677-.322-.677Zm.883.392-.719.215.719-.215Zm-.85 7.13a.75.75 0 1 0 0 1.5v-1.5Zm2.652 1.81a.75.75 0 0 0 1.06 1.061l-1.06-1.06ZM15 9.335l.53.53a.75.75 0 0 0 0-1.06l-.53.53Zm-1.06-2.121a.75.75 0 0 0-1.061 1.06l1.06-1.06Zm-1.262-2.488a.75.75 0 1 0 .644-1.355l-.644 1.355Zm.966 10.381a.75.75 0 0 0-.883-1.212l.883 1.212Zm-1.19-1.113H2.274v1.5h10.181v-1.5ZM1.75 13.47V5.198H.25v8.272h1.5Zm.523.523a.523.523 0 0 1-.523-.523H.25c0 1.117.906 2.023 2.023 2.023v-1.5Zm0-10.818A2.023 2.023 0 0 0 .25 5.198h1.5c0-.289.234-.523.523-.523v-1.5Zm0 1.5h1.909v-1.5h-1.91v1.5Zm2.231-.073 6.012-2.863L9.871.385 3.86 3.248l.645 1.354Zm-.322.073h7.636v-1.5H4.182v1.5Zm7.636 0h.636v-1.5h-.636v1.5Zm-1.46-3.006L11.1 4.14l1.437-.43-.742-2.472-1.437.431Zm.158.07a.114.114 0 0 1-.158-.07l1.437-.43A1.386 1.386 0 0 0 9.871.384l.645 1.354Zm3.423 9.716 1.591-1.59-1.06-1.061-1.591 1.59 1.06 1.061Zm1.591-2.651-1.59-1.591-1.061 1.06 1.59 1.591 1.061-1.06Zm-5.303 1.28H15v-1.5h-4.773v1.5Zm2.227-5.409c.082 0 .157.018.224.05l.644-1.355a2.018 2.018 0 0 0-.867-.195v1.5Zm0 10.818c.444 0 .856-.143 1.19-.387l-.883-1.212a.517.517 0 0 1-.306.1v1.5Z"
    />
  </svg>
)
export default pay_from
